/*
  Whop Checkout - redireciona o carrinho da Magic Football Store (loja principal,
  dknyr9-z3.myshopify.com) pro checkout customizado (Whop Payments) em vez do
  checkout nativo da Shopify.

  Portado de tema-live-temp/layout/theme.liquid (tema Kalles, ao vivo em producao)
  para o tema Dawn. Logica identica - o selector do botao de checkout depende de
  `name="checkout"`, um atributo padrao da Shopify presente tanto no Kalles quanto
  no Dawn (confirmado em snippets/cart-drawer.liquid, snippets/cart-notification.liquid
  e sections/main-cart-footer.liquid deste tema), entao nao precisou de adaptacao.

  META PIXEL: o InitiateCheckout e o Purchase sao mandados pelo SERVIDOR (whop-checkout/)
  pra Conversions API - nao daqui. Testado em producao no Kalles: um fbq('track', ...)
  disparado no navegador bem no instante em que a pagina troca de dominio se perde com
  frequencia (o navegador aborta a chamada de rede no meio da navegacao, ou bloqueador de
  anuncio derruba) - server-side nao tem esse problema. Este script continua responsavel
  por UMA coisa relacionada a isso: capturar os cookies _fbp/_fbc (criados pelo pixel do
  app oficial "Facebook & Instagram", que so existem no dominio da Shopify) e mandar pro
  backend junto com o carrinho - sem isso o servidor nao teria como saber de qual
  anuncio/visita esse checkout veio.

  IMPORTANTE sobre a "rede de seguranca": o checkout nativo da Shopify (/checkout,
  checkouts/cn/...) e uma aplicacao SEPARADA que nao carrega layout/theme.liquid - ou
  seja, nenhum script daqui roda la. Nao tem como interceptar por JS quem ja chegou no
  checkout nativo; a unica defesa real e cobrir TODOS os botoes que levam pra la antes
  do clique (o que este script faz) e desligar os botoes de checkout acelerado
  (Shop Pay/PayPal/Google Pay, via `content_for_additional_checkout_buttons`) nas
  configuracoes do tema ("Show dynamic checkout buttons" na secao do carrinho) - eles
  NAO sao cobertos por este script.
*/
(function () {
  var WHOP_CHECKOUT_BASE_URL = 'https://www.checkoutmagic.shop';

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? decodeURIComponent(match[2]) : null;
  }

  // Se o cookie _fbc ainda nao existe (cliente clicou no anuncio antes do pixel do
  // app oficial gravar o cookie), reconstroi a partir do ?fbclid= na URL - formula
  // documentada oficialmente pela Meta (fb.1.<timestamp_ms>.<fbclid>).
  function getFbc() {
    var existing = getCookie('_fbc');
    if (existing) return existing;
    var fbclid = new URLSearchParams(window.location.search).get('fbclid');
    return fbclid ? 'fb.1.' + Date.now() + '.' + fbclid : null;
  }

  // button[name="checkout"] e o atributo padrao da Shopify (dispara o checkout nativo
  // ao submeter o form do carrinho) - cobre pagina de carrinho, drawer e mini-carrinho
  // de notificacao neste tema.
  var CHECKOUT_BUTTON_SELECTOR = 'button[name="checkout"]';

  function preserveUtm(url) {
    var current = new URLSearchParams(window.location.search);
    var target = new URL(url);
    current.forEach(function (value, key) {
      if (key.indexOf('utm_') === 0) target.searchParams.set(key, value);
    });
    return target.toString();
  }

  function buildLineItems(cart) {
    return cart.items.map(function (item) {
      return {
        variantId: 'gid://shopify/ProductVariant/' + item.variant_id,
        title: item.product_title,
        quantity: item.quantity,
        // item.final_price (NAO item.price) - e o preco por unidade DEPOIS de
        // descontos automaticos da Shopify (ex: promo "buy X get Y"). item.price
        // e sempre o preco cheio, ignora qualquer desconto - usar ele fazia o
        // checkout cobrar o valor errado em carrinhos com a promocao ativa.
        price: item.final_price / 100, // /cart.js retorna centavos
        originalPrice: item.price / 100,
        discountLabel: (item.discounts && item.discounts[0] && item.discounts[0].title) || null,
        image: item.image || null,
        variantTitle: item.variant_title || null,
        // personalizacao (nome/numero da camisa) - line item properties do /cart.js,
        // precisa chegar ate o pedido final como customAttributes (ver webhooks.js)
        properties: item.properties || null,
      };
    });
  }

  // rel="noreferrer" + clique simulado suprime o header Referer/document.referrer
  // so nesta navegacao especifica pro checkout - ao contrario de um <meta
  // name="referrer"> no <head> do tema, que valeria pra qualquer link de saida
  // do site inteiro. window.location = url sempre manda o referrer completo, nao
  // tem como suprimir so nele.
  function navigateWithoutReferrer(url) {
    var link = document.createElement('a');
    link.href = url;
    link.rel = 'noreferrer';
    document.body.appendChild(link);
    link.click();
  }

  function goToWhopCheckout(button) {
    if (button) button.disabled = true;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items.length) throw new Error('carrinho vazio');
        var lineItems = buildLineItems(cart);
        return fetch(WHOP_CHECKOUT_BASE_URL + '/checkout/create', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            lineItems: lineItems,
            // fbp/fbc capturados AINDA no dominio da Shopify - checkoutmagic.shop e
            // outro dominio, nao tem acesso a esses cookies sozinho (ver server/
            // routes/checkout.js e server/meta.js pra como sao usados depois).
            meta: { fbp: getCookie('_fbp'), fbc: getFbc(), eventSourceUrl: window.location.href },
          }),
        });
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data || !data.checkoutUrl) throw new Error('resposta sem checkoutUrl');
        navigateWithoutReferrer(preserveUtm(data.checkoutUrl));
      })
      .catch(function (err) {
        console.error('[whop-checkout] erro ao redirecionar:', err);
        if (button) button.disabled = false;
        alert('Não foi possível abrir o checkout. Tente novamente em instantes.');
      });
  }

  function processButton(btn) {
    if (btn.dataset.whopIntercepted) return;
    btn.dataset.whopIntercepted = '1';
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      goToWhopCheckout(btn);
    });
  }

  function scan() {
    document.querySelectorAll(CHECKOUT_BUTTON_SELECTOR).forEach(processButton);
  }

  // O carrinho (pagina e drawer) e atualizado via AJAX pelo tema - os botoes sao
  // recriados nesses momentos, entao um MutationObserver reprocessa a cada mudanca
  // do DOM em vez de depender de um nome de evento customizado especifico do tema.
  document.addEventListener('DOMContentLoaded', scan);
  new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
})();
